import { combineReducers } from 'redux'

import geoLocationListService from './list/geoLocationListService'
import * as selectors from './list/geoLocationListService.selectors'
import * as actions from './list/geoLocationListService.actions'

export const geoLocationServiceActions = {
  ...actions,
}

export const geoLocationServiceSelectors = {
  ...selectors,
}

export const geoLocationServiceReducers = combineReducers({
  list: geoLocationListService,
})
